import { render } from "./Testimonials.vue?vue&type=template&id=861106b4"
import script from "./Testimonials.vue?vue&type=script&lang=js"
export * from "./Testimonials.vue?vue&type=script&lang=js"
script.render = render

export default script